export enum TraccUsageKeys {
  USER_NAME = "username",
  FULL_NAME = "fullName",
  EMAIL = "email",
  ORGANISATION_NAME = "organisationName",
  CALCULATION_TYPE = "calculationType",
  CREATED_AT = "createdAt",
}